export const DeviceIdLocalStorageKeyConst: string = 'deviceId'
